import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import useInventario, { LOAD_MESSAGE } from './InventarioHook'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalInventario from './ModalInventario'
import ModalConfirmarExclusaoInventario from './ModalConfirmarExclusaoInventario'

function Inventario({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useInventario()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, { selectedInventario: state.selectedInventario })
    }
  }, [state.pathToRedirect])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INVENTARIOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getInventariosOnPeriodo(
          selectedTp,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
        )
        break

      case LOAD_MESSAGE.GET_ESTOQUES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.fetchEstoques(selectedTp)
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteInventario(
          selectedTp,
          state.selectedInventario.inventario_id,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>8.9 - Inventario</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={localDispatch.onNovo}
          showBtnNovo={selectedTp}
          onVoltar={history.goBack}
        >
          <React.Fragment>
            <div className="p-grid">
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                textPesquisar="Procurar Inventários"
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.getInventarioBySearch(selectedTp, pInicial, pFinal)
                }
              />

              <div className="p-col-12">
                <div style={{ marginTop: 15 }}>
                  <DataTable
                    header={
                      <CustomDataTableHeader
                        onChange={value => localDispatch.onChange('globalFilter', value)}
                        value={state.globalFilter}
                      />
                    }
                    globalFilter={state.globalFilter}
                    onRowClick={e =>
                      localDispatch.onChange('selectedPosicao', e.data.posicao_estoque_id)
                    }
                    value={state.inventarios}
                    rows={10}
                    paginator={true}
                    emptyMessage="Não existe movimentação de expedição para o TP selecionado."
                  >
                    <Column field="inventario_id" header="Código" style={tableCellCentered(60)} />
                    <Column field="created_at" header="Criado Em" style={tableCellCentered(80)} />
                    <Column
                      field="finished_at"
                      header="Finalizado Em"
                      style={tableCellCentered(80)}
                    />
                    <Column field="inventario" header="Inventario" style={tableCellCentered(120)} />
                    <Column field="company" header="Empresa" style={tableCellCentered()} />
                    <Column field="estoque" header="Estoque" style={tableCellCentered()} />
                    <Column
                      field="qte_stock_positions"
                      header="Qte Posições"
                      style={tableCellCentered(80)}
                    />
                    <Column field="status" header="Status" style={tableCellCentered()} />
                    <Column
                      header="Menu"
                      style={tableCellCentered(70)}
                      body={pick => (
                        <ThreeDots
                          items={localDispatch.getMenuItems()}
                          onClick={item => localDispatch.onMenuItemClicked(item, pick, selectedTp)}
                        />
                      )}
                      bodyStyle={tableCellCentered()}
                    />
                  </DataTable>
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
      <ModalInventario
        pFinal={state.periodo.dataFinal}
        pInicial={state.periodo.dataInicial}
        data={state.modal.data}
        isVisible={state.modal.show}
        onClose={localDispatch.onClose}
        onError={localDispatch.onError}
        onSave={localDispatch.onSave}
        estoques={state.estoques}
      />
      <ModalConfirmarExclusaoInventario
        isVisible={state.deleteModal.show}
        inventario={state.deleteModal.data}
        onClose={localDispatch.onCloseDeleteModal}
        onConfirm={localDispatch.onConfirmDelete}
        onError={localDispatch.onError}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Inventario))
